import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { UpdateFundingRequestBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const updateFundingRequest = createApiThunk<void, UpdateFundingRequestBody>(
  "fundingRequests/updateFundingRequest",
  async (body, { extra: { adminRepository } }) => {
    return adminRepository!.updateFundingRequest(body);
  },
);

export const resetUpdateFundingRequest = createAction("fundingRequests/resetUpdateFundingRequest");
